import camelCase from './camelCase';
import Component from '../components/Component';

export default class ComponentRouter {
  constructor(components, pageComponents = []) {
    this.components = components;
    this.pageComponents = pageComponents;
    this.registeredComponents = {};
  }

  get(component) {
    console.log(component)
    return this.registeredComponents[this.convertCase(component)] || false;
  }

  convertCase(string) {
    string = camelCase(string);

    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  registerComponents() {
    this.pageComponents.map(this.convertCase).forEach((component) => {
      if (typeof this.components[component] === 'function') {
        this.registeredComponents[component] = new this.components[component];
      }
    });
  }

  loadComponents() {
    Object.keys(this.registeredComponents).forEach((key) => this.registeredComponents[key].load());
  }
}
